import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import SydButton from '../../../../commonDesign/Button'
import NullValue from '../../../../molecules/NullValue'

const useStyles = makeStyles((theme) => ({
  noDetails: {
    color: theme.palette.text.secondary,
    fontStyle: 'italic'
  }
}))

export const EventLogDetailsDialogContext = React.createContext(null)

function EventLogDetailsCell ({ value, row }) {
  const classes = useStyles()
  const dialogRef = useContext(EventLogDetailsDialogContext)

  if (!value) {
    return (
      <NullValue>
        <span className={classes.noDetails}>no details</span>
      </NullValue>
    )
  }

  const handleClick = () => {
    if (dialogRef?.current) {
      dialogRef.current.open(row.original.eventLogId)
    }
  }

  return (
    <SydButton
      variant='ghost'
      size='sm'
      onClick={handleClick}
    >
      View Details
    </SydButton>
  )
}

EventLogDetailsCell.propTypes = {
  value: PropTypes.number,
  row: PropTypes.object
}

export default EventLogDetailsCell
